module.exports = __webpack_public_path__ + "img/password.5b4b8e76.svg";